var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-box"},_vm._l((_vm.buttonList),function(item,index){return _c('el-button',{key:index,staticStyle:{"height":"30px"},attrs:{"type":item.type,"plain":"","disabled":item.disabled,"size":"small"},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick(item.onclick)}}},[_vm._v(_vm._s(item.value))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }